<div class="stt-container jk-border flex" [class.hidden-input]="hideInput()">
  <div class="stt-controls">
    <button
      mat-fab
      [color]="isRecording ? 'warn' : 'primary'"
      (click)="toggleRecording()"
      [disabled]="isProcessing"
      class="record-button"
      [attr.aria-label]="isRecording ? '停止錄音' : '開始錄音'">
      {{ isRecording ? '🔴' : '⏹️' }}
    </button>

    @if (isProcessing) {
      <mat-spinner diameter="24" class="processing-spinner"></mat-spinner>
    }

    <button
      mat-icon-button
      (click)="copyToClipboard()"
      [disabled]="!hasResult"
      color="primary"
      aria-label="複製到剪貼簿">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>

  <mat-form-field appearance="outline" class="stt-input">
    <mat-label>語音辨識結果</mat-label>
    <input
      matInput
      [(ngModel)]="transcribedText"
      [placeholder]="isRecording ? '錄音中...' : '點擊麥克風開始錄音'"
      [disabled]="isProcessing">
  </mat-form-field>

  @if (originalText()) {
    <mat-form-field appearance="outline" class="stt-input">
      <mat-label>原始辨識結果</mat-label>
      <input matInput [value]="originalText()" readonly>
    </mat-form-field>
  }

  @if (hasError) {
    <div class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage() }}</span>
      <button mat-button color="primary" (click)="retry()">重試</button>
    </div>
  }
</div>
